var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsersWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.089,
    height: 17.329,
    viewBox: "0 0 26.089 17.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-group",
    "data-name": "Icon material-group",
    d: "M17.924,14.07a3.285,3.285,0,1,0-3.285-3.285A3.271,3.271,0,0,0,17.924,14.07Zm-8.76,0A3.285,3.285,0,1,0,5.88,10.785,3.271,3.271,0,0,0,9.165,14.07Zm0,2.19c-2.551,0-7.665,1.281-7.665,3.832V22.83H16.829V20.092C16.829,17.541,11.716,16.26,9.165,16.26Zm8.76,0c-.318,0-.679.022-1.062.055a4.621,4.621,0,0,1,2.157,3.778V22.83h6.57V20.092C25.589,17.541,20.476,16.26,17.924,16.26Z",
    transform: "translate(-0.5 -6.5)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersWhite);
export default __webpack_public_path__ + "static/media/users-white.19f0dbcdaa47f1aa2f25f6968fad934a.svg";
export { ForwardRef as ReactComponent };